<template>
    <v-card component="Order" :disabled="isProjectLoading" :loading="isProjectLoading">
        <v-card-text>
            <order-header />
            <div class="order">
                <div class="header">
                    <div class="name">{{ getOrderProject ? getOrderProject.nazov : 'N/A' }}</div>
                    <div>{{ getProjectTypeName }}</div>
                    <div>{{ getProjectLength }}</div>
                    <div>{{ getProjectTeritory }}</div>
                    <div>{{ getProjectTimespan }}</div>
                    <div class="price">
                        {{ getOrderProject ? getOrderProject.price.base_price : '-' }} <small>EUR</small>
                    </div>
                </div>
                <div v-if="!characterList.length" class="empty">Drop characters here</div>
                <draggable
                    class="items"
                    :sort="false"
                    :disabled="getOrderProject && getOrderProject.hasOrder"
                    v-bind="dragOptions"
                    :group="{ name: 'order', pull: false }"
                    :list="characterList"
                    filter="input"
                    :prevent-on-filter="false"
                >
                    <order-item
                        v-for="(character, index) in getOrderProject ? getOrderProject.order_character_list : []"
                        :key="character.id"
                        :index="index"
                        :disabled="getOrderProject && getOrderProject.hasOrder"
                        :character="character"
                        :typ="getOrderProject.detail.typ"
                        @removeFromCharacterList="removeFromCharacterList"
                    >
                    </order-item>
                </draggable>
                <!--                <div class="footer">-->
                <!--                    <div class="line">-->
                <!--                        <div>Total without agency commission:</div>-->
                <!--                        <div class="val">-->
                <!--                            {{ getOrderProject ? getOrderProject.price.base_price : '-' }} <small>EUR</small>-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                    <div class="line commision">-->
                <!--                        <div>Agency commission (15%):</div>-->
                <!--                        <div class="val">-->
                <!--                            {{ getOrderProject ? getOrderProject.price.provision : '-' }} <small>EUR</small>-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                    <div class="line sum">-->
                <!--                        <div>Total without VAT:</div>-->
                <!--                        <div class="val">-->
                <!--                            {{ getOrderProject ? getOrderProject.price.without_dph : '-' }} <small>EUR</small>-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                </div>-->
            </div>
            <order-footer />
        </v-card-text>
    </v-card>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import CharacterList from '@/components/Project/Character/CharacterList.vue';
import OrderItem from './OrderItem.vue';
import draggable from 'vuedraggable';
import moment from 'moment';
import OrderHeader from '@/components/Project/Order/OrderHeader';
import OrderFooter from '@/components/Project/Order/OrderFooter';

export default {
    name: 'Order',

    data() {
        return {
            loading: true,
            immediate: true,
            characterList: [],
            dragOptions: {
                ghostClass: 'ghost',
            },
        };
    },

    async mounted() {
        if (this.$route.params.project_id) {
            await this.loadOrderProject(this.$route.params.project_id);
            this.characterList = this.getOrderProject ? this.getOrderProject.order_character_list : [];
        }
        this.loading = false;
    },

    methods: {
        ...mapActions(['loadOrderProject', 'updateOrderProject']),
        ...mapMutations(['setOrderProjectCharacters']),

        removeFromCharacterList(character_id) {
            this.characterList.splice(
                this.characterList.findIndex((character) => character.id === character_id),
                1
            );
        },
    },

    computed: {
        ...mapGetters([
            'isProjectLoading',
            'getOrderProject',
            'getProjectTypeName',
            'getProjectLength',
            'getProjectTeritory',
            'getProjectTimespan',
        ]),
    },

    watch: {
        characterList: {
            handler(val) {
                if (this.immediate) {
                    this.immediate = false;
                    return;
                }
                this.setOrderProjectCharacters(val);
                this.updateOrderProject(this.getOrderProject);
            },
        },
    },

    components: {
        OrderFooter,
        OrderHeader,
        CharacterList,
        OrderItem,
        draggable,
    },
};
</script>

<style lang="less">
@import '~@variables';

.flip-list-move {
    transition: transform 0.5s;
}

.ghost {
    opacity: 0.5;
    background: #c8ebfb;
    display: flex;
}

[component='Order'] {
    .v-card__text {
        padding-top: 0;
    }

    .order {
        position: relative;
        border-radius: 10px;
        box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 10%), 0 2px 2px 0 rgba(0, 0, 0, 14%), 0 1px 15px 0 rgba(0, 0, 0, 15%) !important;

        .header {
            width: 100%;
            .flex-row;
            justify-content: space-between;
            background-color: @grey_lt;
            border-radius: 10px 10px 0 0;
            color: @black;
            font-weight: bold;

            div {
                padding: 10px 15px 6px;
            }

            .price {
                text-align: right;
            }

            div {
                text-align: center;
                padding: 8px 15px;
                flex-grow: 1;
                width: 20%;

                &.name {
                    text-align: left;
                }
            }
        }

        .empty {
            position: absolute;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 13px;
            left: 0;
            padding-left: 15px;
            width: 100%;
            height: 40px;
            pointer-events: none;
            background-color: fade(@black, 5%);
            color: fade(@black, 50%);
            border-bottom: 1px solid @border;
        }

        .items {
            position: relative;
            min-height: 40px;
        }

        .footer {
            .flex-column;
            align-items: flex-end;
            font-size: 12px;
            padding: 10px 15px;

            .line {
                display: flex;
                align-items: center;
                justify-content: flex-end;

                &.commision {
                    //.border-b;
                }

                &.sum {
                    //padding-top: 8px;
                }
            }

            .val {
                text-align: right;
                font-weight: bold;
                font-size: 14px;
                color: @black;
                min-width: 110px;
            }
        }
    }
}
</style>
